// src/context/AuthContext.jsx
import { createContext, useState, useEffect, useCallback } from 'react';

export const AuthContext = createContext({
  user: null,
  updateUser: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    try {
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error al parsear el usuario almacenado:", error);
      return null;
    }
  });

  // Función para actualizar el usuario y sincronizar en localStorage
  const updateUser = useCallback((newUser) => {
    setUser(newUser);
    if (newUser) {
      localStorage.setItem('user', JSON.stringify(newUser));
    } else {
      localStorage.removeItem('user');
    }
  }, []);

  // Escuchar cambios en localStorage para sincronizar en otras pestañas
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === 'user') {
        try {
          const updatedUser = event.newValue ? JSON.parse(event.newValue) : null;
          setUser(updatedUser);
        } catch (error) {
          console.error("Error al parsear el cambio de usuario en localStorage:", error);
        }
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return (
    <AuthContext.Provider value={{ user, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};